import { Dialog, DialogContent } from '@mui/material'
import { useStatusStore } from 'stores/status.store'
import { typeForGet, typeOffPay, typeWFH } from '../../../constants/submitType'
import { FormSubmitType } from '../../../types/submitFormType'
import FormSubmit from './FormSubmit'

export type DialogFormProps = {
  eventClicked: any
}

export default function DialogForm({ eventClicked }: DialogFormProps) {
  const open = useStatusStore((state) => state.isOpenSubmitForm)
  const onClose = () => useStatusStore.getState().setIsOpenSubmitForm(false)

  const defaultValues: FormSubmitType = {
    typeSubmit: 'create'
  }

  switch (eventClicked?.extendedProps?.type) {
    case 'WFH':
      defaultValues.typeSubmit = typeWFH.value
      defaultValues.dateSubmit = new Date(eventClicked?.start)
      defaultValues.timeStart = eventClicked?.extendedProps?.firstIn
        ? undefined
        : new Date(`2024-01-01 08:30:00`)
      defaultValues.timeEnd = eventClicked?.extendedProps?.lastOut
        ? undefined
        : new Date(`2024-01-01 17:30:00`)
      break
    case 'Office':
      defaultValues.typeSubmit = typeForGet.value
      defaultValues.dateSubmit = new Date(eventClicked?.start)
      defaultValues.timeStart = eventClicked?.extendedProps?.firstIn
        ? undefined
        : new Date(`2024-01-01 08:30:00`)
      defaultValues.timeEnd = eventClicked?.extendedProps?.lastOut
        ? undefined
        : new Date(`2024-01-01 17:30:00`)
      defaultValues.startDate = new Date(eventClicked?.start)
      defaultValues.endDate = new Date(eventClicked?.start)
      break
    default:
      defaultValues.typeSubmit = typeOffPay.value
      defaultValues.typeDate = 'all_day'
      defaultValues.startDate = new Date(eventClicked?.start)
      defaultValues.endDate = new Date(eventClicked?.start)
      break
  }
  if (eventClicked?.extendedProps) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            minWidth: 'min(600px, 95%)',
            maxWidth: '95vw'
          }
        }}
      >
        <DialogContent>
          <FormSubmit initialValues={defaultValues} />
        </DialogContent>
      </Dialog>
    )
  }
  return null
}
